import React from "react";
import PendingButton from "components/common/PendingButton";
import { Trans } from "react-i18next";

export const SaveButton = ({
  onClick,
  form,
  disabled,
  pending,
  children = "Save",
  ...props
}) => {
  const formDisabled = form ? !form.$form.valid : false;
  const formPending = form ? form.$form.pending : false;
  const isDisabled = typeof disabled !== "undefined" ? disabled : formDisabled;
  const isPending = typeof pending !== "undefined" ? pending : formPending;

  return (
    <PendingButton
      color="primary"
      onClick={onClick}
      disabled={isDisabled}
      pending={isPending}
      {...props}
    >
      <Trans>{children}</Trans>
    </PendingButton>
  );
};

export default SaveButton;
